import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Función para guardar la información de la tarjeta de emergencia
 */
export async function crearTarjetaEmergencia({ commit, state }) {
    await $http.post('prod_emergency_card_create', state.selectedTarjetaEmergencia)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
                timer: 3000
            })

            commit('setIdTarjetaEmergencia', response.data.id)
            state.errorTarj = false
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.error,
                showConfirmButton: true,
                timer: 3000
            })
            commit('tarjetaEmergenciaError', error.message)
        })
}

/**
 * Función para obtener la información de la tarjeta de emergencia
 * @param int id Id de la tarjeta de emergencia
 */
export async function mostrarTarjetaEmergencia({ commit, rootState }, id) {
    await $http.get(`prod_emergency_card/${id}/show`, { params: { id_producto: rootState.productos.selectedProduct.id } })
        .then((response) => {
            commit('setTarjetaEmergencia', response.data.data)
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 3000
            })
            commit('tarjetaEmergenciaError', error.message)
        })
}

/**
 * Función para obtener los productos de la empresa
 */
export async function getProductosEmpresa({ commit, state }, requestParameters = { params: state.filtro }) {

    await $http.get('productos/empresa', requestParameters)
        .then((response) => {
            commit('setProductos', response.data)
        })
        .catch((error) => {})

}

/**
 * Función para mostrar la información de la tarjeta de emergencia
 */
export async function actualizarTarjetaEmergencia({ commit, state, dispatch, rootState }) {
    $http.put(`prod_emergency_card_update`, state.selectedTarjetaEmergencia)
        .then((response) => {

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
                timer: 5000
            })
            dispatch('mostrarTarjetaEmergencia', state.selectedTarjetaEmergencia.id, { params: { id_producto: rootState.productos.selectedProduct.id } })
            state.errorTarj = false
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
            commit('accionError', error.message)
        })
}



/**
 * Función para crear el pdf de la tarjeta de emergencia
 * @param int id Id de la tarjeta de emergencia
 */
export async function crearPdfTarjeta({commit, state}, id) {
    try {
        const response = await $http({
            url: `prod_emergency_card_generatePdf`,
            method: "GET",
            responseType: "blob",
            params: state.pdf
        })
        const endPointPDF = window.URL.createObjectURL(response.data);
        return Promise.resolve(endPointPDF);
    } catch (e) {
        const data = await e.text();
        const error = JSON.parse(data);
        commit('tarjetaEmergenciaError', error.message)
    }

}

/**



/**
 * Función para descargar el pdf de la tarjeta de emergencia
 * @param int id Id del producto
 * @returns {Promise<void>}
 */
export async function descargarPdfTarjeta({ commit, state }, id ) {
    commit('dashboard/load', true, {root: true});
    await $http({
      url: `productos/tarjetas_emergencia/descargar/${id}`,
      method: "GET",
      responseType: "blob"
    }).then((response) => {
      new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `TajetaEmergencia.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
      .catch((error) => {
        console.log(error.message);
      })
    commit('dashboard/load', false, {root: true});
}

/**
 * Función para obtener la asignacion de tarjeta de emergencia por empresa y producto.
 * @param int id_empresa Id de la empresa consultada
 * @param int id_producto Id del producto consultado
 */
export async function getAsignacionTarjetasEmergencia({commit, state}, requestParameters) {

  commit('dashboard/load', true, {root: true});
  await $http.get(`/productos/tarjetas_emergencia/empresa_producto/${requestParameters.id_empresa}/${requestParameters.id_producto}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setAsignacionTarjetasEmergencia', response.data.data);
      state.error = false;
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
    });
}

export async function setAcgihDefecto({commit, state}, data) {
  let res = 'Ningún componente con límites de exposición establecido por la ACGIH.';
  let componentesProductoPeligro = data.componentesProductoPeligro;
  if (componentesProductoPeligro.length !== 0) {
    let tlvs = componentesProductoPeligro.filter((ct) => ct.lista === 'TLV')[0];
    if (tlvs.components.length !== 0) {
      let tlv_default = '';
      tlvs.components.forEach(function (tlv) {
        let acgihtwa_obj = tlv.fields.filter((field) => field.label === "ACGIH TWA");
        let acgihtwa_val = '';
        if (acgihtwa_obj.length !== 0) {
          acgihtwa_obj = acgihtwa_obj[0];
          acgihtwa_val = acgihtwa_obj.value;
        }
        let acgihstel_obj = tlv.fields.filter((field) => field.label === "ACGIH STEL");
        let acgihstel_val = '';
        if (acgihstel_obj.length !== 0) {
          acgihstel_obj = acgihstel_obj[0];
          acgihstel_val = acgihstel_obj.value;
        }
        let acgihstelsimb_obj = tlv.fields.filter((field) => field.label === "ACGIH STEL UNIDADES");
        let simb_stel_obj = '';
        let simb_stel_val = '';
        if (acgihstelsimb_obj.length !== 0) {
          acgihstelsimb_obj = acgihstelsimb_obj[0];
          simb_stel_obj = acgihstelsimb_obj.danger_field_lists.filter((simb) => simb.id === parseInt(acgihstelsimb_obj.value))[0];
          simb_stel_val = simb_stel_obj.lista;
        }
        let basis_obj = tlv.fields.filter((field) => field.label === "BASIS")[0];
        let basis_val = [];
        if (basis_obj !== null) {
          basis_obj.danger_field_lists.forEach((bas) => {
            let val = JSON.parse(basis_obj.value);

            for (let i = 0; i < val.length; i++) {
              if (bas.id === parseInt(val[i])) {
                basis_val.push(bas.lista);
              }
            }
          });
        }
        let acgihtwa = acgihtwa_val;
        let acgihstel = acgihstel_val + ' ' + simb_stel_val;
        let basis = (basis_val.length !== 0) ? `; ${basis_val.join(", ")}` : "";
        tlv_default += `${tlv.name}: ${acgihtwa}${acgihstel}${basis}. `;
      });
      res = tlv_default;
    }
    commit('setAcgih', res);
  }
}


/**
 * Convertir datos del pdf obtenido en base64 a tipo Blob.
 *
 * @param {*} fileBase64: archivo en base 64 que se quiere formatear y devolver en Blob
 * @param {*} contentType: tipo de contenido, ejemplo: 'application/pdf'
 * @returns string
 * @author Fernando Claros
 */
function convertBase64FiletoBlob(fileBase64, contentType = 'application/pdf; application/octet-stream') {

    //application/octet-stream
    const byteArray = Uint8Array.from(window.atob(fileBase64).split('').map(char => char.charCodeAt(0)));

    return new Blob([byteArray], {
        type: contentType
    });
}
